/* Naoko — LP „Black Friday VIP — List do Mikołaja” (docs/lp-bf-vip-list-plan.md): JS skórki naoko-bfl-*.
   Silnik zapisu, filmu, ?typ=1, wjazdu i kopiowania to assets/naoko-vip.js; tu tylko to, czego
   wymaga ten list:
   - znaczki z sekcji „Lista życzeń” przyklejane na list (i na kopertę po zapisie): klik w
     [data-bfl-stamp] → znaczek VIP zamienia się w zdjęcie produktu, animacja przyklejenia po
     przewinięciu do listu; wybór w sessionStorage 'bfl:stamp' (koperta po powrocie z ?typ=1).
     Wybór NIE trafia do Shopify — tylko klik do GTM (data-gtm-el="bfl-stamp", decyzja 31.10),
   - pola w zdaniach listu rosną z tekstem (ch), podpis „Z czułością” pisze się imieniem,
   - przechył 3D znaczka w hero za kursorem, kursor-pióro nad sekcjami LP —
     tylko mysz (hover + pointer: fine), bez prefers-reduced-motion, nie w edytorze motywu.
   Każda sekcja dołącza ten skrypt — blokada drugiego uruchomienia. */
(function () {
  if (window.NaokoBfl) return;
  window.NaokoBfl = true;

  var KEY = 'bfl:stamp';

  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function reduceMotion() { return mq('(prefers-reduced-motion: reduce)'); }
  function finePointer() { return mq('(hover: hover) and (pointer: fine)'); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  function headerOffset() {
    var cs = getComputedStyle(document.body);
    return (parseFloat(cs.getPropertyValue('--header-height')) || 0) +
      (parseFloat(cs.getPropertyValue('--naoko-sticky-banners-height')) || 0);
  }

  /* ---------------- Znaczki → list ---------------- */
  function readStamp() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) { return null; }
  }

  function applyStamp(d) {
    if (!d || !d.img) return;
    document.querySelectorAll('[data-bfl-vip] .nbfl-stamp').forEach(function (st) {
      st.classList.add('is-prod');
      var sin = st.querySelector('.nbfl-sin');
      if (!sin) return;
      sin.textContent = '';
      var im = new Image();
      im.src = d.img;
      im.alt = d.name || '';
      sin.appendChild(im);
    });
    document.querySelectorAll('[data-bfl-stamp]').forEach(function (b) {
      var on = b.getAttribute('data-bfl-stamp') === d.id;
      b.setAttribute('aria-pressed', String(on));
      var ps = b.closest('.nbfl-ps');
      if (ps) ps.classList.toggle('is-on', on);
    });
  }

  function stick() {
    var list = document.querySelector('.nbfl-list');
    if (!list) return;
    var typ = list.classList.contains('is-typ');
    var host = list.querySelector(typ ? '.nbfl-env' : '.nbfl-letter');
    var target = host && host.querySelector('[data-bfl-vip]');
    if (!target) return;
    target.classList.remove('is-stick');
    target.classList.add('is-wait');
    var y = function () {
      return Math.max(0, host.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - headerOffset() - 24);
    };
    window.scrollTo({ top: y(), behavior: 'smooth' });
    /* Animacja dopiero po zatrzymaniu przewijania (jak w makiecie), maks. ~2 s. */
    var last = -1, same = 0, n = 0;
    var iv = setInterval(function () {
      n++;
      var sy = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(sy - last) < 1) same++;
      else same = 0;
      last = sy;
      if (same >= 3 || n > 40) {
        clearInterval(iv);
        setTimeout(function () {
          var r = target.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) {
            var html = document.documentElement, prev = html.style.scrollBehavior;
            html.style.scrollBehavior = 'auto';
            window.scrollTo(0, y());
            html.style.scrollBehavior = prev;
          }
          target.classList.remove('is-wait');
          void target.offsetWidth;
          target.classList.add('is-stick');
        }, 120);
      }
    }, 50);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bfl-stamp]');
    if (!b) return;
    var d = { id: b.getAttribute('data-bfl-stamp'), name: b.getAttribute('data-name') || '', img: b.getAttribute('data-img') || '' };
    try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (_) {}
    applyStamp(d);
    if (!reduceMotion()) stick();
  });

  /* ---------------- List: pola rosnące z tekstem, podpis ---------------- */
  function fit(i) {
    var len = (i.value || '').length || (i.placeholder || '').length;
    i.style.width = (Math.max(len, 6) + 1) + 'ch';
  }

  function initLetter(root) {
    if (root.dataset.bflLetterReady) return;
    root.dataset.bflLetterReady = '1';
    root.querySelectorAll('.nbfl-ink').forEach(function (i) {
      fit(i);
      i.addEventListener('input', function () { fit(i); });
    });
    var name = root.querySelector('[data-vip-field="fname"]');
    var sig = root.querySelector('[data-bfl-sig]');
    if (!name || !sig) return;
    var t;
    var write = function () {
      var v = name.value.trim();
      sig.textContent = v;
      sig.classList.remove('is-typed');
      void sig.offsetWidth;
      if (v) sig.classList.add('is-typed');
    };
    name.addEventListener('input', function () { clearTimeout(t); t = setTimeout(write, 350); });
    if (name.value) write();
  }

  /* ---------------- Hero: przechył 3D ---------------- */
  function initTilt(root) {
    if (root.dataset.bflTiltReady) return;
    root.dataset.bflTiltReady = '1';
    var sw = root.querySelector('[data-bfl-tilt]');
    if (!sw || !finePointer() || reduceMotion() || designMode()) return;
    root.addEventListener('mousemove', function (e) {
      var r = sw.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      sw.style.transform = 'rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg)';
    });
    root.addEventListener('mouseleave', function () { sw.style.transform = ''; });
  }

  /* ---------------- Kursor-pióro nad sekcjami LP ---------------- */
  function initCursor() {
    if (!document.querySelector('[data-bfl-cursor]') || document.querySelector('.nbfl-cur')) return;
    if (!finePointer() || reduceMotion() || designMode()) return;
    var cd = document.createElement('div');
    cd.className = 'nbfl-cur';
    cd.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cd);
    window.addEventListener('mousemove', function (e) {
      var t = e.target;
      var inLp = !!(t.closest && t.closest('.nbfl'));
      cd.classList.toggle('is-show', inLp);
      if (!inLp) return;
      cd.style.transform = 'translate(' + (e.clientX + 16) + 'px,' + (e.clientY + 18) + 'px)';
      cd.classList.toggle('is-hot', !!t.closest('a,button,label,input,select,textarea,[role=button],.nbfl-ps'));
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () { cd.classList.remove('is-show'); });
  }

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('.nbfl-letter').forEach(initLetter);
    r.querySelectorAll('.nbfl-hero').forEach(initTilt);
    initCursor();
    applyStamp(readStamp());
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
